export const QuestionTypes = {
    'multiChoices': '1',
    'essay': '2',
}

export function generateRandomId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
  
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
  
    return result;
}

// The app talks to the backend on the host it was served from.
//
// Two branches used to sit here mapping any "ics" or "ivyis" origin onto
// that client's own canonical hostname. Both were redundant: they only
// fired when the page was already being served from that exact host, so they
// computed what the fallback below computes anyway - while putting another
// client's hostname into every client's bundle.
//
// The iatseg branch is kept because it is NOT redundant: it rewrites to the
// apex domain, dropping the subdomain, which the fallback would not do.
let domain = "";
if (window.location.origin.includes("iatseg")) {
    domain = "iatseg.org"
} else if (window.location.hostname !== "localhost") {
    domain = window.location.hostname
} else {
    domain = "localhost"
}


export const BASE_URL = domain == "localhost" ? "http://localhost/Interactive_Videos/backend":`https://${domain}/backend`;

export   const  HOMEPAGE  = domain =="localhost" ?"http://localhost:3002" :`https://${domain}`;

// export const Grades = [
//    {
//       id: 1,
//       title: "KG 1",
//    },
//    {
//       id: 2,
//       title: "KG 2",
//    },
// ]

// export const Subjects = [
//    {
//       id: 1,
//       title: "Math",
//    },
//    {
//       id: 2,
//       title: "Science",
//    },
// ]